const modal = {
	CHARGE: 'CHARGE',
	CLOSE: 'CLOSE',
	SETTLE: 'SETTLE',
	INVOICE: 'INVOICE',
};

export default modal;